import makeStyles from '@material-ui/core/styles/makeStyles';
import Alert from '@material-ui/lab/Alert';
import clsx from 'clsx';
import React from 'react';

const muiColors = ['error', 'success', 'warning', 'info'];

const useStyles = makeStyles((theme) => ({
  small: { padding: '7px 10px' },
  'label-filled': {},
  'label-standard': {},
  'label-outlined': { color: theme.palette.gray.main, borderColor: theme.palette.gray.fade },
}));

export default function InfoBar({ children, type, className, color, variant, size = '', ...rest }) {
  const styles = useStyles();
  const isCustomColor = !muiColors.includes(color);

  return (
    <Alert
      className={clsx(className, size && styles[size], isCustomColor && styles[`${color}-${variant}`])}
      severity={type}
      variant={variant}
      color={!isCustomColor ? color : undefined}
      {...rest}
    >
      {children}
    </Alert>
  );
}
